module.exports = __webpack_public_path__ + "static/img/theme-img1.3736a852.jpg";